<template>
  <div class="h-100">
    <b-container fluid="" class="px-0">
      <page-header
        :page-title="streamInfo ? streamInfo.title : ''"
        :page-icon="streamInfo ? streamInfo.icon : ''"
        @back="backToStream"
      />
    </b-container>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center h-100">
      <b-spinner class="align-middle" variant="secondary" />
    </div>
    <div v-else class="max-width container-fluid">
      <div class="row d-flex justify-content-center h-100">
        <div class="col-md-8 position-inherit">
          <highlightable>
            <div v-for="block in blocks(currentPage)" :key="block.id">
              <stream-block-container :block="block" :user-id="Number(userId)" />
            </div>
          </highlightable>
          <slot name="extra-block"></slot>
          <hr />
          <div class="row mt-4 mb-5">
            <div class="col-6">
              <b-button
                variant="link"
                class="text-primary px-0"
                @click="setCurrentPage(currentPage - 1)"
                v-if="currentPage !== 1"
                >{{ trans("streams.back") }}</b-button
              >
            </div>
            <div class="col-6 pb-md-0 pb-5 text-right">
              <b-button
                variant="secondary"
                @click="setCurrentPage(currentPage + 1)"
                v-if="currentPage < pagesLength"
              >
                {{ trans("streams.continue") }}
              </b-button>

              <loading-button
                v-else
                :loading="nextLoading"
                variant="secondary"
                :button-text="trans('streams.continue')"
                @click="$emit('onPagesCompleted')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PageHeader from "../PageHeader";
import StreamBlockContainer from "../StreamBlockContainer";
import navMixin from "../../mixins/navMixin";
import LoadingButton from "../../atoms/LoadingButton";
import Highlightable from "../../molecules/Highlightable";

export default {
  components: { LoadingButton, PageHeader, StreamBlockContainer, Highlightable },
  name: "StreamPageContainer",
  props: {
    nextLoading: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.setPage();
  },
  methods: {
    ...mapMutations({
      setCurrentPage: "streams/setCurrentPage",
    }),
    backToStream() {
      this.$emit("backToStream");
    },
    updateRoute(page) {
      this.$router.push(`?page=${page}`).catch((err) => {});
    },
    setPage() {
      this.setCurrentPage(this.$route.query.page ? Number(this.$route.query.page) : 1);
    },
  },
  mixins: [navMixin],
  computed: {
    ...mapGetters({
      blocks: "streams/getPageBlocks",
      isLoading: "streams/getLoadingPageState",
      pagesLength: "streams/getPagesLength",
      currentPage: "streams/getCurrentPage",
      userId: "user/getUserId",
      streamInfo: "streams/getStreamInfo",
      missionStatus: "streams/getMissionStatus",
    }),
  },
  watch: {
    currentPage: function (val) {
      this.updateRoute(val);
    },
    $route(to, from) {
      this.setPage();
    },
  },
};
</script>

<style scoped lang="scss">
.position-inherit {
  position: inherit;
}
</style>
